import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../components/Navbar/NavBar';
import heroImg from '../images/clients/bac.jpg'; 

class Hero extends Component {
    render() {
        const heroStyles = {
            backgroundImage: `url(${heroImg})`, 
            backgroundSize: 'cover', 
            backgroundPosition: 'center', 
            backgroundRepeat: 'no-repeat', 
            height: '100vh', 
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '90px'       
        };

        return (
            <>
                <div style={heroStyles} className="hero" id="hero">
                    <NavBar />

                    <div className="m-auto overflow-hidden mx-4 mt-8 lg:mt-4 p-2 md:p-12 h-5/6" data-aos="zoom-in">
                        <div className="flex flex-col lg:flex-row py-8 justify-between text-center lg:text-left">
                            <div className="lg:w-1/2 flex flex-col justify-center" data-aos="zoom-in" data-aos-delay="200">
                                <h1 className="mb-5 md:text-5xl text-3xl font-bold" style={{color: 'white', marginRight: '300px', textAlign: 'left'}}>
                                    Achetez et vendez sans bouger de chez vous.                        
                                </h1>
                                <div className="text-xl font-semibold tracking-tight mb-5" style={{color: '#E4E0E1', textAlign: 'left'}}>
                                    Découvrez des offres exclusives et trouvez tout ce dont vous avez besoin en un seul clic sur notre marketplace !      
                                </div>
                                <div style={{marginRight: '400px'}} className="mb-4 space-x-0 md:space-x-2 md:mb-8">
                                    <Link 
                                        to="/connexion" 
                                        className="text-white inline-flex items-center justify-center w-full px-6 py-3 my-4 text-lg shadow-xl rounded-2xl sm:w-auto sm:mb-0" 
                                        style={{backgroundColor: '#C53E3E', textDecoration: 'none'}}
                                    >
                                        Rejoignez-nous
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Hero;
